import {
  COMMON_REQUEST_GET_AFQS_BEGIN,
  COMMON_REQUEST_GET_AFQS_SUCCESS,
  COMMON_REQUEST_GET_AFQS_FAILURE,
  COMMON_REQUEST_GET_AFQS_DISMISS_ERROR,
  COMMON_REQUEST_GET_AFQS_URL
} from './constants';

import httpService from '../../../common/httpService';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function requestGetAfqs(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: COMMON_REQUEST_GET_AFQS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = httpService.get(COMMON_REQUEST_GET_AFQS_URL.replace('{tenantId}', args.tenantId));
      doRequest.then(
        (res) => {
          dispatch({
            type: COMMON_REQUEST_GET_AFQS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: COMMON_REQUEST_GET_AFQS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissRequestGetAfqsError() {
  return {
    type: COMMON_REQUEST_GET_AFQS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_REQUEST_GET_AFQS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        requestGetAfqsPending: true,
        requestGetAfqsError: null,
      };

    case COMMON_REQUEST_GET_AFQS_SUCCESS:
      // The request is success
      return {
        ...state,
        requestGetAfqsPending: false,
        requestGetAfqsError: null,
        applications: action.data
      };

    case COMMON_REQUEST_GET_AFQS_FAILURE:
      // The request is failed
      return {
        ...state,
        requestGetAfqsPending: false,
        requestGetAfqsError: action.data.error,
        applications: []
      };

    case COMMON_REQUEST_GET_AFQS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        requestGetAfqsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/requestGetAfqs.js